module.exports = __webpack_public_path__ + "img/bower-and-wilkins-speaker.127b67cd.jpg";